import React from "react";
import StickyNavbar from "../navbar";
import { Link } from "react-router-dom";
import * as motion from "motion/react-client"
import timeline from "../images/timeline.png";

const Chapter2 = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const hoverEffect = {
    whileHover: { scale: 1.05 },
    transition: { duration: 0.3 },
  };

  return (
    <div>
      <StickyNavbar />

      <motion.div
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 text-lg"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div className="text-center mb-8" variants={fadeIn}>
          <p className="text-[#005FFF] py-5 md:text-xl">Intended Behavioural Outcome (IBO)</p>
          <p>
            The Community Health Extension Worker will carry out research
            ethically (WHAT) with members of the community (WITH WHOM) by
            following ethical guidelines, such as getting their consent to take
            part in research and keeping their information private (HOW). This
            focus on ethical research will be followed in every research setting
            (WHERE), at every stage of the research (WHEN), protecting people’s
            safety and trust in the research.
          </p>
        </motion.div>

        <motion.div className="space-y-8" variants={fadeIn}>
          <div>
            <h2 className="text-xl font-bold mb-2 text-[#005FFF]">History of research ethics</h2>
            <p>
            As we said, research ethics is about doing research responsibly and sensitively, and protecting people from harm. Research ethics has been shaped by events in history that have shown us the need for clear guidelines to protect everyone involved. Understanding this history helps us appreciate the importance of carrying out research responsibly (53-55).
            </p>
            {/* <ul className="list-disc list-inside space-y-4">
              <li>
                Beginning with Nazi Germany example of scientific misconduct and
                unethical experimentation
              </li>
              <li>Helsinki declaration</li>
              <li>Nuremberg Code</li>
              <li>Easy to understand, reading age at 9</li>
            </ul> */}
          </div>

          <motion.div
            className="rounded-lg py-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex justify-center">
              <img src={timeline} alt="Research ethics timeline" />
            </div>
          </motion.div>

          
        </motion.div>

        <div className="flex justify-between mt-10">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/video">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/principles">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default Chapter2;
